// Shared footer for every create form. Left side shows a summary
// (e.g. "0 milestones · 2026-Q2"), right side has Cancel + Primary.

import { DC } from "./primitives";

interface FooterProps {
  primary: string;
  disabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  summary?: string;
  error?: string | null;
  color?: string;
}

export function Footer({
  primary,
  disabled,
  onCancel,
  onSubmit,
  summary,
  error,
  color = "var(--bsp-blue)",
}: FooterProps) {
  return (
    <div
      style={{
        borderTop: `1px solid ${DC.border}`,
        background: DC.surfaceMuted,
        padding: "12px 22px",
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        {error ? (
          <div style={{ color: DC.redFg, fontSize: 12 }}>{error}</div>
        ) : summary ? (
          <div
            style={{
              color: DC.grey,
              fontSize: 11,
              fontStyle: "italic",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {summary}
          </div>
        ) : null}
      </div>
      <button
        type="button"
        onClick={onCancel}
        className="bsp-btn bsp-btn-ghost"
        style={{ height: 36 }}
      >
        Cancel
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={onSubmit}
        className="bsp-btn bsp-btn-primary"
        style={{
          height: 36,
          background: disabled ? undefined : color,
          borderColor: disabled ? undefined : color,
        }}
      >
        {primary}
      </button>
    </div>
  );
}
